/** Prefer the application revision token; proxies may rewrite the transport ETag. */
export const responseVersion=response=>response.headers.get('X-DCMS-Version')||response.headers.get('ETag');
